import angular from 'angular';
import readonlyField from './readonlyField';

export default angular
  .module('components.readonlyField', [])
  .component('readonlyField', readonlyField).name;
